import { Tooltip, TextInput } from '@mantine/core';
import { extractEmailUsernameSuffixValue } from '~/common/stably-email/destruct-email';
import { isStablyEmail } from '~/common/stably-email/is-stably-email';
import { env } from '~/env.mjs';
import { SENSITIVE_VARIABLE_VALUE } from '~/components/settings/Variables';
import { useProjectId } from '~/hooks/context/useProjectId';
import { useViewModeValue } from '~/hooks/context/useViewMode';

export default function VariableValueInput({
  value,
  sensitive,
  orgPrefix,
  onChange,
  error,
  className = 'flex-1',
}: {
  value?: string;
  sensitive: boolean;
  orgPrefix: string;
  onChange: (value: string) => void;
  error?: string;
  className?: string;
}) {
  const projectId = useProjectId();
  const viewMode = useViewModeValue(projectId);
  // Only show special email formatting UI in classic mode
  const showEmailFormatting = viewMode === 'classic' && value && isStablyEmail(value);

  return (
    <Tooltip
      withArrow
      w={220}
      multiline
      color="gray"
      label="This variable is sensitive. You and your team cannot read the value of this variable after it has been created."
      disabled={!sensitive}
    >
      {showEmailFormatting ?
        <TextInput
          type={sensitive ? 'password' : 'text'}
          key="dynamic"
          className={className}
          leftSection={`${orgPrefix}+`}
          leftSectionWidth={`${orgPrefix}+`.length * 7 + 10}
          rightSection={`@${env.NEXT_PUBLIC_STABLY_EMAIL_DOMAIN}`}
          rightSectionWidth={`@${env.NEXT_PUBLIC_STABLY_EMAIL_DOMAIN}`.length * 7}
          value={extractEmailUsernameSuffixValue(value, orgPrefix)}
          onChange={(event) => {
            const email = `${orgPrefix}+${event.currentTarget.value}@${env.NEXT_PUBLIC_STABLY_EMAIL_DOMAIN}`;
            onChange(email);
          }}
          error={error}
        />
      : <div className={className}>
          {sensitive ?
            <TextInput
              type="password"
              placeholder={SENSITIVE_VARIABLE_VALUE}
              value={value}
              onChange={(event) => {
                onChange(event.currentTarget.value);
              }}
              error={error}
            />
          : <TextInput
              placeholder="Value"
              value={value}
              onChange={(event) => {
                onChange(event.currentTarget.value);
              }}
              error={error}
            />
          }
        </div>
      }
    </Tooltip>
  );
}
